import api from './api';

const endpoint = '/api/v1/ecommerce/store/lookup';

export default {
    async lookup(zipcode = '', locationId = '', isPassport = false, timestamp = '') {
        const queryParams = [
          `zipcode=${zipcode}`,
          `locationId=${locationId}`,
          `is_passport=${(isPassport ? '1' : '0')}`,
          `timestamp=${timestamp}`,
        ].join('&')
        return await api.get(`${endpoint}?${queryParams}`);
    }
}
